import { connect } from "react-redux";
import { Actions as BAMBOO_ACTIONS } from "./store/bambooActions";

import { ExclamationTriangleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { toTitleCase } from "@/components/common/validation/Validators";

const ImportDepartmentsModal = ({
	modalOpen,
	closeModal,
	section,
	agreement,
	diff,
	issues,
	saving,
	confirmPushChanges,
}) => {
	if (!modalOpen || !section || !agreement) return null;

	const errors = issues?.filter((item) => item.type === "error") || [];
	const warnings = issues?.filter((item) => item.type === "warning") || [];

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b">
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={() => {
											closeModal();
										}}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Update {toTitleCase(section)} on Bamboo HR</h3>
						</div>
						<div className="content">
							{Object.keys(diff || {}).length > 0 && (
								<>
									<h4 className="block-title push-10">Difference</h4>
									<div
										className="table-responsive"
										style={{ marginBottom: 0 }}
									>
										<div
											id="active-people-table_wrapper"
											className="dataTables_wrapper no-footer"
										>
											<table
												id="active-people-table"
												className="js-table-sections table table-hover"
											>
												<thead style={{ display: "table-header-group" }}>
													<tr>
														<th>FIELD</th>
														<th>FROM</th>
														<th>TO</th>
													</tr>
												</thead>
												<tbody>
													{Object.keys(diff).map((key) => {
														const diffItem = diff[key];
														const name = key
															.replace("__added", "")
															.replace("__deleted", "");
														const deleted = key.includes("__deleted");
														const added = key.includes("__added");

														return (
															<tr key={key}>
																<td>{name}</td>
																<td>{deleted ? diffItem : diffItem?.__old}</td>
																<td>{added ? diffItem : diffItem?.__new}</td>
															</tr>
														);
													})}
												</tbody>
											</table>
										</div>
									</div>
								</>
							)}
							{warnings.length > 0 && (
								<>
									<h4 className="block-title push-10">
										<ExclamationTriangleIcon
											className="text-warning"
											style={{ height: "2rem", verticalAlign: "sub" }}
										/>{" "}
										Warnings
									</h4>
									<div className="table-responsive">
										<div
											id="active-people-table_wrapper"
											className="dataTables_wrapper no-footer"
										>
											<table
												id="active-people-table"
												className="js-table-sections table table-hover"
											>
												<thead style={{ display: "table-header-group" }}>
													<tr>
														<th>Message</th>
														<th>Expected</th>
														<th>Received</th>
													</tr>
												</thead>
												<tbody>
													{warnings.map((warning) => (
														<tr key={warning.message}>
															<td>{warning.message}</td>
															<td>{warning.expected}</td>
															<td>{warning.received}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
								</>
							)}
							{errors.length > 0 && (
								<>
									<h4 className="block-title push-10">
										<ExclamationTriangleIcon
											className="text-danger"
											style={{ height: "2rem", verticalAlign: "sub" }}
										/>{" "}
										Errors
									</h4>
									<div className="table-responsive">
										<div
											id="active-people-table_wrapper"
											className="dataTables_wrapper no-footer"
										>
											<table
												id="active-people-table"
												className="js-table-sections table table-hover"
											>
												<thead style={{ display: "table-header-group" }}>
													<tr>
														<th>Message</th>
													</tr>
												</thead>
												<tbody>
													{errors.map((error) => (
														<tr key={error.message}>
															<td>{error.message}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
								</>
							)}
						</div>
						<div
							className="content"
							style={{ marginBottom: "1rem" }}
						>
							<button
								onClick={() => {
									closeModal();
								}}
								className="btn btn-default"
							>
								Cancel
							</button>
							{!issues?.length ? (
								<button
									type="submit"
									className="btn btn-success pull-right"
									disabled={saving}
									onClick={() => {
										confirmPushChanges();
									}}
								>
									{saving ? "Saving..." : "Confirm"}
								</button>
							) : (
								<button
									type="submit"
									className="btn btn-danger pull-right"
									disabled={saving}
									onClick={() => {
										confirmPushChanges();
									}}
								>
									{saving ? "Saving..." : "Proceed Regardless"}
								</button>
							)}
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { bambooHr } = { ...state.integration?.hris };

	return {
		modalOpen: bambooHr?.pushChangesModal,
		...bambooHr?.pushChangesModal,
		saving: bambooHr?.pushingChanges,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(BAMBOO_ACTIONS.toggleUpdateModal({})),
	confirmPushChanges: () => dispatch(BAMBOO_ACTIONS.confirmPushChanges()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportDepartmentsModal);
